<template>
  <div class="page contact-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">想了解产品、合作或售后，都可以通过下面的方式找到我们。</p>
    <ContactFriend placement="hero" />
    <h2>联系方式</h2>
    <ul class="contact-details">
      <li>服务热线：400-831-7518（周一至周日 9:00-18:00）</li>
      <li>商务合作：aguang@zixiancao.com、wangfengyi@zixiancao.com</li>
      <li>公司地址：广东省深圳市龙岗区大运软件小镇</li>
      <li>微信公众号：滋仙草；官方抖音：滋仙草旗舰店</li>
    </ul>
    <p class="record">备案号：粤ICP备2024239587号</p>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/contact.html')

export default {
  name: 'ContactPage',
  components: {
    ContactFriend
  },
  data() {
    return { page }
  }
}
</script>

<style scoped>
.page {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

h2 {
  color: #4b0082;
  font-size: 1.1em;
  margin: 20px 0 8px;
}

.page-intro,
li {
  color: #333;
  line-height: 1.8;
}

.contact-details {
  padding-left: 18px;
  margin: 0;
}

.record {
  color: #666;
  font-size: 0.9em;
  margin-top: 16px;
}
</style>
